/* eslint-disable import/no-unresolved */
import { render, Fragment } from '@wordpress/element';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import domReady from '@wordpress/dom-ready';

import './index.css';

const PartyTrend = () => {
    const highchartsArgs = {
        credits: { enabled: false },
        exporting: { enabled: false },
        colors: ['#456A83', '#D1A730', '#BF3B27', '#ACC4D3', '#EBABA2'],
        chart: {
            type: 'line',
            marginBottom: 70,
            renderTo: 'chart',
        },
        title: {
            text: '',
        },
        xAxis: {
            type: 'datetime',
            plotBands: [
                {
                    color: '#F5F4EF',
                    from: Date.UTC(1939, 0, 1),
                    to: Date.UTC(1945, 3, 11),
                    label: {
                        text: 'Roosevelt',
                        rotation: 270,
                        textAlign: 'left',
                        verticalAlign: 'bottom',
                        y: -5,
                    },
                },
                {
                    color: '#FFFFFF',
                    from: Date.UTC(1945, 3, 12),
                    to: Date.UTC(1953, 0, 19),
                    label: {
                        text: 'Truman',
                        rotation: 270,
                        textAlign: 'left',
                        verticalAlign: 'bottom',
                        y: -5,
                    },
                },
                {
                    color: '#F5F4EF',
                    from: Date.UTC(1953, 0, 20),
                    to: Date.UTC(1961, 0, 19),
                    label: {
                        text: 'Eisenhower',
                        rotation: 270,
                        textAlign: 'left',
                        verticalAlign: 'bottom',
                        y: -5,
                    },
                },
                {
                    color: '#FFFFFF',
                    from: Date.UTC(1961, 0, 20),
                    to: Date.UTC(1963, 10, 21),
                    label: {
                        text: 'Kennedy',
                        rotation: 270,
                        textAlign: 'left',
                        verticalAlign: 'bottom',
                        y: -5,
                    },
                },
                {
                    color: '#F5F4EF',
                    from: Date.UTC(1963, 10, 22),
                    to: Date.UTC(1969, 0, 19),
                    label: {
                        text: 'Johnson',
                        rotation: 270,
                        textAlign: 'left',
                        verticalAlign: 'bottom',
                        y: -5,
                    },
                },
                {
                    color: '#FFFFFF',
                    from: Date.UTC(1969, 0, 20),
                    to: Date.UTC(1974, 7, 8),
                    label: {
                        text: 'Nixon',
                        rotation: 270,
                        textAlign: 'left',
                        verticalAlign: 'bottom',
                        y: -5,
                    },
                },
                {
                    color: '#F5F4EF',
                    from: Date.UTC(1974, 7, 9),
                    to: Date.UTC(1977, 0, 19),
                    label: {
                        text: 'Ford',
                        rotation: 270,
                        textAlign: 'left',
                        verticalAlign: 'bottom',
                        y: -5,
                    },
                },
                {
                    color: '#FFFFFF',
                    from: Date.UTC(1977, 0, 20),
                    to: Date.UTC(1981, 0, 19),
                    label: {
                        text: 'Carter',
                        rotation: 270,
                        textAlign: 'left',
                        verticalAlign: 'bottom',
                        y: -5,
                    },
                },
                {
                    color: '#F5F4EF',
                    from: Date.UTC(1981, 0, 20),
                    to: Date.UTC(1989, 0, 19),
                    label: {
                        text: 'Reagan',
                        rotation: 270,
                        textAlign: 'left',
                        verticalAlign: 'bottom',
                        y: -5,
                    },
                },
                {
                    color: '#FFFFFF',
                    from: Date.UTC(1989, 0, 20),
                    to: Date.UTC(1993, 0, 19),
                    label: {
                        text: 'Bush',
                        rotation: 270,
                        textAlign: 'left',
                        verticalAlign: 'bottom',
                        y: -5,
                    },
                },
                {
                    color: '#F5F4EF',
                    from: Date.UTC(1993, 0, 20),
                    to: Date.UTC(2001, 0, 19),
                    label: {
                        text: 'Clinton',
                        rotation: 270,
                        textAlign: 'left',
                        verticalAlign: 'bottom',
                        y: -5,
                    },
                },
                {
                    color: '#FFFFFF',
                    from: Date.UTC(2001, 0, 20),
                    to: Date.UTC(2009, 0, 19),
                    label: {
                        text: 'Bush',
                        rotation: 270,
                        textAlign: 'left',
                        verticalAlign: 'bottom',
                        y: -5,
                    },
                },
                {
                    color: '#F5F4EF',
                    from: Date.UTC(2009, 0, 20),
                    to: Date.UTC(2015, 0, 1),
                    label: {
                        text: 'Obama',
                        rotation: 270,
                        textAlign: 'left',
                        verticalAlign: 'bottom',
                        y: -5,
                    },
                },
            ],
        },
        yAxis: {
            gridLineWidth: 1,
            gridLineDashStyle: 'longdash',
            gridLineColor: '#D7D7D7',
            min: 0,
            max: 60,
            title: {
                enabled: false,
            },
        },
        tooltip: {
            xDateFormat: '%Y',
            shared: true,
        },
        plotOptions: {
            series: {
                lineWidth: 3,
            },
            line: {
                marker: {
                    enabled: false,
                },
            },
        },

        series: [
            {
                name: 'Democrat',
                data: [
                    41,
                    41,
                    null,
                    47,
                    44,
                    41,
                    43,
                    40,
                    40,
                    40,
                    45,
                    45,
                    40,
                    42,
                    46,
                    46,
                    45,
                    43,
                    44,
                    46,
                    46,
                    46,
                    51,
                    49,
                    49,
                    51,
                    50,
                    47,
                    42,
                    42,
                    41,
                    43,
                    43,
                    42,
                    41,
                    44,
                    43,
                    46,
                    46,
                    46,
                    44,
                    45,
                    41,
                    44,
                    43,
                    39,
                    34,
                    35,
                    35,
                    35,
                    34,
                    33,
                    31,
                    33,
                    34,
                    32,
                    30,
                    33,
                    33,
                    33,
                    34,
                    33,
                    34,
                    31,
                    31,
                    33,
                    33,
                    33,
                    33,
                    36,
                    34,
                    33,
                    32,
                    33,
                    32,
                    32,
                ],
                pointStart: Date.UTC(1939, 2, 15),
                pointInterval: 365 * 24 * 3600 * 1000,
            },
            {
                name: 'Independent',
                data: [
                    18,
                    19,
                    null,
                    18,
                    20,
                    20,
                    15,
                    22,
                    23,
                    23,
                    19,
                    18,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    21,
                    22,
                    23,
                    23,
                    20,
                    22,
                    23,
                    23,
                    24,
                    25,
                    28,
                    28,
                    29,
                    28,
                    29,
                    30,
                    31,
                    31,
                    33,
                    29,
                    30,
                    28,
                    32,
                    29,
                    30,
                    27,
                    30,
                    29,
                    29,
                    30,
                    31,
                    31,
                    30,
                    29,
                    33,
                    36,
                    34,
                    34,
                    33,
                    33,
                    32,
                    32,
                    34,
                    30,
                    29,
                    30,
                    31,
                    30,
                    30,
                    30,
                    34,
                    32,
                    35,
                    35,
                    37,
                    36,
                    38,
                    39,
                ],
                pointStart: Date.UTC(1939, 2, 15),
                pointInterval: 365 * 24 * 3600 * 1000,
            },
            {
                name: 'Republican',
                data: [
                    35,
                    35,
                    null,
                    35,
                    35,
                    38,
                    33,
                    37,
                    36,
                    35,
                    32,
                    31,
                    31,
                    33,
                    32,
                    31,
                    32,
                    33,
                    33,
                    30,
                    29,
                    29,
                    28,
                    27,
                    26,
                    25,
                    25,
                    26,
                    27,
                    27,
                    27,
                    27,
                    25,
                    26,
                    24,
                    23,
                    21,
                    22,
                    21,
                    22,
                    21,
                    23,
                    27,
                    25,
                    24,
                    29,
                    32,
                    31,
                    30,
                    30,
                    32,
                    31,
                    31,
                    28,
                    27,
                    30,
                    31,
                    29,
                    28,
                    28,
                    27,
                    28,
                    29,
                    30,
                    30,
                    30,
                    29,
                    28,
                    25,
                    25,
                    24,
                    25,
                    24,
                    25,
                    24,
                    23,
                ],
                pointStart: Date.UTC(1939, 2, 15),
                pointInterval: 365 * 24 * 3600 * 1000,
                visible: true,
            },
        ],
    };

    return (
        <Fragment>
            <p>
                For more than 70 years, with few exceptions, more Americans have
                identified as Democrats than Republicans. But the share of
                independents, which surpassed the percentages of either
                Democrats or Republicans several years ago, continues to
                increase. Currently, 39% Americans identify as independents, 32%
                as Democrats and 23% as Republicans. This is the highest
                percentage of independents in more than 75 years of public
                opinion polling. <strong>Report: </strong>
                <a
                    href="https://www.people-press.org/2015/04/07/a-deep-dive-into-party-affiliation/"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    A Deep Dive Into Party Affiliation
                </a>
            </p>
            <p>
                <em>% of Americans who say they are ...</em>
            </p>
            <div id="interactive">
                <HighchartsReact
                    highcharts={Highcharts}
                    options={highchartsArgs}
                />

                <p className="source">
                    <b>Note:</b> 1939-1989 yearly averages from the Gallup
                    Organization interactive website. 1990-2014 yearly totals
                    from Pew Research Center aggregate files. Based on the
                    general public. Data unavailable for 1941. Independent data
                    unavailable for 1951-1956.
                </p>
            </div>
        </Fragment>
    );
};

domReady(function() {
    if (document.getElementById('js-party-id-trend')) {
        render(<PartyTrend />, document.getElementById('js-party-id-trend'));
    }
});
